import { Fragment as F } from 'react';
import { Routes as DomRoutes, Route, Link, useParams, useLocation, Navigate } from 'react-router-dom';
import ErrorBoundary from '@corefact/toolchain/components/ErrorBoundary';
import PageRoutes from 'configs/routes';
import React, { Suspense, lazy } from 'react';

const AllRoutes = Object.values(PageRoutes).reduce((acc, route) => {
    return [
        ...acc,
        ...Array.isArray(route.path) ? route.path.map((path) => ({
            ...route,
            path,
        })) : route,
    ];
}, []).map((route) => ({
    ...route,
    path: route.path?.toLowerCase?.(),
}));

function HookWrapper({ component }) {
    let params = useParams(),
        location = useLocation(),
        _Component = component.default || component;

    return (
        <ErrorBoundary>
            <_Component {...{ match: { location, params } }} />
        </ErrorBoundary>
    )
}

function LazyHookWrapper({ component }) {
    let params = useParams(),
        location = useLocation(),
        _Component = lazy(component);

    return (
        <ErrorBoundary>
            <Suspense>
                <_Component {...{ match: { location, params } }} />
            </Suspense>
        </ErrorBoundary>
    )
}

function RouteListing(props) {
    return (
        <dl className='RouteListing'>
            <dt>Routes:</dt>
            {
                props.routes.map((route) => {
                    return (
                        <dd key={route.path || `${route.from || Math.random()} - ${route.to || Math.random()}`}>
                            <details className={route.requiresAuth ? 'auth' : 'noauth'}>
                                <summary>
                                    <Link className='RouteLink' to={route.path}>{route.path}</Link>
                                    {
                                        route.example && (<F> - Example: <Link className='RouteLink' to={route.example}>{route.example}</Link></F>)
                                    }
                                </summary>
                                <pre>
                                    {
                                        JSON.stringify({
                                            ...route,
                                            component: route.component ? (route.component instanceof Function ? route.component : route.component.default).toString() : undefined,
                                        }, null, 4)
                                    }
                                </pre>
                            </details>
                        </dd>
                    );
                })
            }
        </dl>
    )
}

export function Routes() {
    var defaultRoute = AllRoutes?.find?.(route => route.isDefault)?.path || '/';
    if (!/^#\//.test(window.location.hash)) {
        window.location.hash = defaultRoute;
    }
    return (
        <DomRoutes>
            {
                AllRoutes.map((route) => {
                    return (!(route.component instanceof Function)) ? (
                        <Route exact={route.exact} path={route.path} element={<HookWrapper component={route.component} />} key={route.path} />
                    ) : (
                        <Route exact={route.exact} path={route.path} element={<LazyHookWrapper component={route.component} />} key={route.path} />
                    )
                })
            }
            <Route exact path="/" element={<RouteListing routes={AllRoutes} />} />
            <Route path="*" element={<Navigate to={defaultRoute} />} /> {/* Redirect to default route if no routes match. */}
        </DomRoutes>
    );
}